export default "__VITE_ASSET__DoE9fQrx__"